import { useEffect } from 'react';

interface UseCloseOnEscProps {
  onClose: () => void;
  activate?: boolean;
}

export const useCloseOnEsc = ({ onClose, activate = true }: UseCloseOnEscProps): void => {
  useEffect(() => {
    if (!activate) return;

    const handleKeyPress = (e: KeyboardEvent): void => {
      if (e.code === 'Escape') onClose && onClose();
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);
};
